<template>
    <form @submit.prevent="submitForm">
     <div class="form-container">
        <div class="clear">
          <div class="form-element float-left" :class="{ 'error': errors.firstName }">
              <label for="first_name" class="title">First Name</label>
              <input name="first_name" type="text" id="first_name" v-model="fields.firstName" placeholder=""
                :keydown="clearError('firstName')" :change="clearError('firstName')"
              >
              <div v-if="errors.firstName" class="error-message">{{ errors.firstName }}</div>
          </div>
          <div class="form-element float-right" :class="{ 'error': errors.lastName }">
              <label for="last_name" class="title">Last Name</label>
              <input name="last_name" type="text" id="last_name" v-model="fields.lastName" placeholder=""
                :keydown="clearError('lastName')" :change="clearError('lastName')"
              >
              <div v-if="errors.lastName" class="error-message">{{ errors.lastName }}</div>
          </div>
        </div>
        <div class="clear">
          <div class="form-element float-left" :class="{ 'error': errors.emailId }">
              <label for="email" class="title">Email</label>
              <input name="email" type="text" id="email" v-model="fields.emailId" placeholder=""
                :keydown="clearError('emailId')" :change="clearError('emailId')"
              >
              <div v-if="errors.emailId" class="error-message">{{ errors.emailId }}</div>
          </div>
          <div class="form-element float-right" :class="{ 'error': errors.password }">
              <label for="password" class="title">Password</label>
              <input name="password" type="password" id="password" v-model="fields.password" placeholder=""
                :keydown="clearError('password')" :change="clearError('password')"
              >
              <div v-if="errors.password" class="error-message">{{ errors.password }}</div>
          </div>
        </div>
        <div class="clear">
          <div class="form-element float-left" :class="{ 'error': errors.creditCard }">
              <label for="credit_card" class="title">Credit Card</label>
              <input name="credit_card" type="text" id="credit_card" placeholder="" v-model="fields.creditCard"
                :keydown="clearError('creditCard')" :change="clearError('creditCard')"
              >
              <span>Secure transmission</span>
              <div v-if="errors.creditCard" class="error-message">{{ errors.creditCard }}</div>
          </div>
          <div class="form-element float-right" :class="{ 'error': errors.zipCode }">
              <label for="zip_code" class="title">Zip Code</label>
              <input name="zip_code" type="text" id="zip_code" v-model="fields.zipCode"
                :keydown="clearError('zipCode')" :change="clearError('zipCode')"
              >
              <div v-if="errors.zipCode" class="error-message">{{ errors.zipCode }}</div>
          </div>
        </div>
        <div class="clear">
            <div class="form-element">
                <input id="terms_conditions" type="checkbox" name="terms_conditions" v-model="fields.termsConditions"
                  class="styled-checkbox" :class="{ 'error': errors.termsConditions }">
                <label for="terms_conditions" class="">Accept terms and conditions</label>
                <div v-if="errors.termsConditions" class="error-message">{{ errors.termsConditions }}</div>
            </div>
            <div class="form-element">
                <input id="email_optin" type="checkbox" name="email_optin" v-model="fields.emailOptin" class="styled-checkbox">
                <label for="email_optin" class="">Email Opt-in</label>
            </div>
          </div>
          <div class="button-container flex-wrapper flex-wrap">
              <button class="button pink midsize wide">Continue</button>
              <div class="click-details"><a href="#">Click here</a> if you have other credit cards you’d like to add to your <br>BeKind Rewards membership.</div>
          </div>
    </div>

  </form>
</template>
<script>
    export default {
        components: {

        },
        data() {
            return {
              fields: {},
              errors: {},

              firstName: null,
              lastName: null,
              emailId: null,
              password: null,
              creditCard: null,
              zipCode: null,
              termsConditions: false,
              emailOptin: false,
            };
        },
        watch: {
        },
        methods: {
            submitForm() {
              //Clear errors
              this.errors = {};
              this.validate();
            },

            validate() {
              if(!this.firstName){
                this.errors.firstName = "This field is required";
              }
              if(!this.lastName){
                this.errors.lastName = "This field is required";
              }
              /* if(!this.emailId){
                console.log('No email');
                this.errors.emailId = "This field is required";
              }  */
              if (!this.emailId) {
                this.errors.emailId = "Email field is required";
              } else if (!this.validEmail(this.emailId)) {
                this.errors.emailId = "Valid email required";
              }
              if(!this.password){
                this.errors.password = "This field is required";
              }
              if(!this.creditCard){
                this.errors.creditCard = "This field is required";
              }
              if(!this.zipCode){
                this.errors.zipCode = "This field is required";
              }
            },

            validEmail: function (email) {
              var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return re.test(email);
            },
            clearError(key) {
              /* console.log('Error');
              this.errors[key] = '';
              this.errors.error = ''; */
            }
        },
    }
</script>
<style lang="scss">
    //@import "../../../sass/app.scss";
</style>